import { CatalogCategoryAboutSection } from '@/widgets/catalog-category-about-section/ui/CatalogCategoryAboutSection';

export { CatalogCategoryAboutSection };
